'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = getSagaModel;

var _reduxSagaModel = require('redux-saga-model');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 获取saga model实例化对象
 * @param { object } history 同react-router history
 * @param { object } reducers 为经过combineReducer的reducers
 * @param { any } preloadedState 请参考redux的createStore第二参数
 * @param { array } models 请参考redux-saga-model说明
 * @param { array } plugins 请参考redux-saga-model说明
 */
function getSagaModel(history, reducers, preloadedState) {
  var models = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var middlewares = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var plugins = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var openReduxDevTools = arguments[6];

  var initialState = preloadedState;
  var initialReducer = (0, _extends3.default)({}, reducers, {
    routing: _reactRouterRedux.routerReducer
  });
  console.log(openReduxDevTools);
  var initialMiddleware = [(0, _reactRouterRedux.routerMiddleware)(history)].concat((0, _toConsumableArray3.default)(middlewares));
  var initialModels = models;
  var sagaModel = new _reduxSagaModel.SagaModel({
    initialState: initialState,
    initialReducer: initialReducer,
    initialMiddleware: initialMiddleware,
    initialModels: initialModels,
    history: history,
    openReduxDevTools: openReduxDevTools
  });
  plugins.forEach(sagaModel.use.bind(sagaModel));
  return sagaModel;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-redux-saga-model/libs/saga-model.js
// module id = 641
// module chunks = 0